import history from './../../router/history';

function catPage (url) {
  return {
    type: 'CATEGORY_NAV_PAGE',
    url
  };
}

function catNav (navigation) {
  return {
    type: 'CATEGORY_NAV',
    navigation
  };
}

function categorySelected (category) {
  return {
    type: 'CATEGORY_SELECTED',
    category
  };
}

const setCatPage = (url) => {
  const split = (input) => {
    const path = '/' + input.split('/')[1];
    let route = '';
    switch (path) {
      case '/photography':
      case '/film':
      case '/fine-art':
      case '/publications':
        route = path;
        break;
      default:
        route = false;
        break;
    };
    return route;
  };
  const catRoute = split(url);
  return (dispatch) => {
    dispatch(catPage(catRoute));
  };
};

const setCatNav = (navigation) => {
  return (dispatch) => {
    dispatch(catNav(navigation));
  };
};

const categorySelectedTrigger = (category) => {
  return (dispatch, getState) => {
    const catNav = getState().category_nav;
    const catsFlat = catNav.map(catNav => catNav.slug);
    if (catsFlat.includes(category) === false) {
      history.push(getState().category_nav_page);
      dispatch(categorySelected('everything'));
    } else {
      dispatch(categorySelected(category));
    }
  };
};

export {
  setCatNav,
  setCatPage,
  categorySelectedTrigger
};



// WEBPACK FOOTER //
// ./src/redux/actions/a_category_nav.js